import { IntegrationChannelType } from 'generated/graphql';

export const getIsIntegrationChannelsMetadataSupported = (
  channelType: IntegrationChannelType,
) => {
  switch (channelType) {
    case IntegrationChannelType.Slack:
    case IntegrationChannelType.Discord:
    case IntegrationChannelType.Discourse:
    case IntegrationChannelType.Typeform:
    case IntegrationChannelType.SurveyMonkey:
    case IntegrationChannelType.Qualtrics:
      return true;
    default:
      return false;
  }
};
